import fetchWrapper from "../utils/fetchWrapper";

const userDataService = () => {
  const getConfiguration = async () => {
    try {
      const settings = await fetchWrapper({ url:"api/configuration", skipAuth: true });
      return settings;
    } catch (e) {
      return {};
    }
  }
  const getUser = async () => {
    try {
      const me = await fetchWrapper({url:"api/me"});
      return me;
    } catch (e) {
      return null;
    }
  }

  return {
    getUser,
    getConfiguration
  }
}

export default userDataService;
